import { render, staticRenderFns } from "./Dicttree.vue?vue&type=template&id=600f0ce0&scoped=true"
import script from "./Dicttree.vue?vue&type=script&lang=js"
export * from "./Dicttree.vue?vue&type=script&lang=js"
import style0 from "./Dicttree.vue?vue&type=style&index=0&id=600f0ce0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600f0ce0",
  null
  
)

export default component.exports